import React, { useState, useEffect } from "react";
import {
  Calendar,
  Clock,
  User,
  UserPlus,
  Eye,
  Pill,
  TestTube,
  Activity,
  ChevronDown,
  MoreVertical,
  Grid,
  List,
  Share2,
} from "lucide-react";
import OurLayouts from "../layout";
import { startUserDetailsFetch } from "../../utils/tokenManager";
import bookappointmenticon from "../../assets/bookappointmenticon.svg";
import nodabookmedicineiconta from "../../assets/bookmedicineicon.svg";
import booklabicon from "../../assets/booklabicon.svg";
import surgery from "../../assets/surgery.svg";
import Ambulanceicon from "../../assets/Ambulanceicon.svg";
import { format } from "date-fns";
import patientvectoricon from "../../assets/patientvectoricon.svg";
import searchicon from "../../assets/search_icon.svg";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import TodayAppointments from "./TodayAppointments";
import PharmacyOrders from "./PharmacyOrders";
import PathologyOrders from "./PathologyOrders";
import RadiologyOrders from "./RadiologyOrders";
import FollowUpPatients from "./FollowUpPatients";
import AmbulanceOrders from "./AmbulanceOrders";
import Surgery from "./getSurgery";
import Delaysidebar from "./Delaysidebar";
import axios from "axios";
import RescheduleSidebar from "../Queuemanagement/RescheduleSidebar";
import noongoing from "../../assets/noongoing.svg";
import nodata from "../../assets/nodata.svg";
import nocurrentpatient from "../../assets/nocurrentpatient.svg";
import VerifyAbhaModal from "../ABHA/VerifyAbhaModal";
import CreateAbhaModal from "../ABHA/CreateAbhaModal";
import { encryptData } from "../../utils/authReducer";
import Kavachicon from "../../assets/Kavachicon.svg";
import Kavachicon1 from "../../assets/Kavachicon1.svg";
import Kavachicon2 from "../../assets/Kavachicon2.svg";
import Kavachicon3 from "../../assets/Kavachicon3.svg";
import Kavachicon4 from "../../assets/Kavachicon4.svg";
import Quantumbanner from "../../assets/quantumbanner.svg";
import Quantumicon from "../../assets/quantumicon.svg";
function formatDoctorDate(dateStr) {
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  return d.toLocaleDateString();
}
// Helper to get today's date formatted
function getTodayDate() {
  const today = new Date();
  return today.toLocaleDateString();
}
// Helper to get today's date in yyyy-MM-dd format
function getTodayDateISO() {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

const getKavachEnrollmentUrl = () => {
  const base = (
    process.env.REACT_APP_API_URL_PATIENTS_FORNTEND || ""
  );
  const hospitalId = localStorage.getItem("hospitalid") || "";
  const hospitaluserId = localStorage.getItem("HospitaluserId") || "";
  const params = new URLSearchParams({ from: "hospital", code: hospitaluserId });
  return `${base}/services/membership?${params.toString()}`;
};

const getQuantumUrl = () => {
  const base = String(process.env.REACT_APP_QUANTUM_URL || "").replace(/\/$/, "");
  return base ? `${base}/` : "";
};

const getHealthSessionBaseUrl = () =>
  String(process.env.REACT_APP_HEALTH_SESSION_URL || "").replace(/\/$/, "");

const patientSearchActionBtn =
  "inline-flex items-center justify-center gap-2 rounded-xl text-sm font-semibold transition-opacity hover:opacity-90 whitespace-nowrap min-w-[100px]";

const SHARE_LINK_GRADIENT_ID = "patientShareLinkGrad";

const ShareLinkGradientDefs = () => (
  <svg width="0" height="0" className="absolute" aria-hidden="true">
    <defs>
      <linearGradient id={SHARE_LINK_GRADIENT_ID} x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#1E4D7B" />
        <stop offset="100%" stopColor="#59B482" />
      </linearGradient>
    </defs>
  </svg>
);

const PatientShareLinkButton = ({
  label,
  loadingLabel = "Sending...",
  onClick,
  disabled,
  isLoading,
}) => (
  <button
    type="button"
    className={`${patientSearchActionBtn} w-full min-w-[152px] cursor-pointer p-[2px] bg-gradient-to-r from-[#1E4D7B] to-[#59B482] hover:opacity-95 disabled:opacity-60 disabled:cursor-not-allowed`}
    onClick={onClick}
    disabled={disabled}
  >
    <span className="inline-flex w-full items-center justify-center gap-2 rounded-[10px] bg-white px-4 py-2.5">
      <Share2
        className="h-4 w-4 shrink-0"
        stroke={`url(#${SHARE_LINK_GRADIENT_ID})`}
        strokeWidth={2.5}
      />
      <span className="bg-gradient-to-r from-[#1E4D7B] to-[#59B482] bg-clip-text text-sm font-semibold text-transparent">
        {isLoading ? loadingLabel : label}
      </span>
    </span>
  </button>
);

const QUANTUM_AI_FEATURES = [
  "SmartVitals",
  "VisionCare",
  "SkinCare",
  "SymptomChecker",
  "CareSathi",
  "SmartDiet",
  "SmartReport",
  "OralCare",
  "LungsCare",
];

const Dashboard = () => {
  const hospitalid = localStorage.getItem("hospitalid") || "";
  const disabledFeatures = JSON.parse(localStorage.getItem("disabledFeatures") || "[]");
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [sendingKavachCode, setSendingKavachCode] = useState(null);
  const [sendingQuantumCode, setSendingQuantumCode] = useState(null);
  const [viewMode, setViewMode] = useState("desktop");
  const API_URL = process.env.REACT_APP_API_URL;
  const [isdelayedOpen, setIsdelayedOpen] = useState(false);
  // Add ongoingPatients state
  const [ongoingPatients, setOngoingPatients] = useState([]);
  // Add doctorList state
  const [doctorList, setDoctorList] = useState([]);
  const [doctordata, setDoctordata] = useState();
  const [resetstatus, setResetstatus] = useState();
  const [selectedHour, setSelectedHour] = useState();
  const [selectedMinute, setSelectedMinute] = useState();
  const [dayofweek, setDayofweek] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [todayAppointments, setTodayAppointments] = useState([]);
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [paidStatus, setPaidStatus] = useState("UNPAID");
  const [doctorAvailabilityDate, setDoctorAvailabilityDate] = useState(
    getTodayDateISO()
  );
  const [selectedSpecialization, setSelectedSpecialization] = useState("");

  const [orders, setOrders] = useState([]);
  const [isRescheduleOpen, setIsRescheduleOpen] = useState(false);
  const [selectedToken, setSelectedToken] = useState("");
  const [selectedappointmentid, setSelectedappointmentid] = useState("");
  const [selectedSlot, setSelectedSlot] = useState("");
  const [rescheduleDate, setRescheduleDate] = useState(new Date());
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [medorders, setmedOrders] = useState([]);
  const [pathologyorders, setpathologyOrders] = useState([]);
  const [radiologyorders, setradiologyOrders] = useState([]);
  const [selecteddoctorid, setSelecteddoctorid] = useState("");
  const [isAbhaVerifyOpen, setIsAbhaVerifyOpen] = useState(false);
  const [isAbhaCreateOpen, setIsAbhaCreateOpen] = useState(false);
  const [selectedPatientForAbha, setSelectedPatientForAbha] = useState(null);
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchInput.trim().length >= 3) {
        handleSearch();
      } else {
        setSearchResults([]);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchInput]);

  async function fetchTodayAppointments() {
    const [startDate, endDate] = dateRange;
    if (!startDate || !endDate) return;
    const clinicId = localStorage.getItem("clinicId");

    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");

    console.log(tenantId, "tenantId");
    if (!token) return;

    const formattedFromDate = format(startDate, "yyyy-MM-dd");
    const formattedToDate = format(endDate, "yyyy-MM-dd");

    let apiUrl = `${API_URL}appointments/prescription?fromDate=${formattedFromDate}&toDate=${formattedToDate}&clinicId=${clinicId}`;
    if (paidStatus !== "ALL") {
      apiUrl += `&paidStatus=${paidStatus}`;
    }

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      });
      if (response.data && Array.isArray(response.data)) {
        setTodayAppointments(response.data);
      } else {
        setTodayAppointments([]);
        console.warn(
          "Appointments data not in expected format: ",
          response.data
        );
      }
    } catch (err) {
      console.error(
        "Fetch error for today's appointments:",
        err.response || err
      );
      toast.error("Could not fetch today's appointments.");
    }
  }

  useEffect(() => {
    fetchTodayAppointments();
  }, [dateRange, paidStatus]);
  useEffect(() => {
    fetchNewAccessToken();
    // Start user details fetch timer
    startUserDetailsFetch();
  }, []);
  async function fetchNewAccessToken() {
    const refreshToken = localStorage.getItem("refresh_token");
    let jsonData = {
        userCode: process.env.REACT_APP_USER_CODE,
        passWord: process.env.REACT_APP_USER_PASSWORD,
        channel: 'M'
      };
    
      let encryptedPayload = encryptData(jsonData); 

    // const payload = {
    //   data: "YLpBA7MjcxWLpgb4m+CxWI6QKnB0NK0APRXasgcP64he68zrk+guYgOCWZOstXE6pWoImfRwdkHlpTysPq3jperkHHakoNiA05tpy5BKrIA=",
    // };
    const response = await fetch(
      `${process.env.REACT_APP_API_URL_CHE}gcp/oauth/token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${refreshToken}`,
        },
        body: JSON.stringify(encryptedPayload),
      }
    );

    const result = await response.json();
    localStorage.setItem("access_token", result.access_token);
  }
  // Fetch ongoing patients from queue API
  useEffect(() => {
    fetchOngoingPatients();
  }, []);
  const fetchOngoingPatients = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${yyyy}-${mm}-${dd}`;
    const url = `${API_URL}queue/waiting-area?date=${formattedDate}`;
    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      });
      const data = await res.json();
      // Extract ongoing patients (nowServing)
      const ongoing = [];
      if (Array.isArray(data)) {
        data.forEach((doctor) => {
          if (doctor?.nowServing?.appointmentId && doctor?.doctorId) {
            ongoing.push({
              id: doctor.nowServing.appointmentId,
              token: doctor.nowServing.token || "",
              patient: doctor.nowServing.name || "Unknown",
              doctor: doctor.doctorName || "",
              status: "Active",
              doctorId: doctor.doctorId || "",
              slot: doctor.nowServing.slot,
            });
          }
        });
      }
      setOngoingPatients(ongoing);
    } catch (error) {
      console.error("Failed to fetch ongoing patients:", error);
    }
  };

  // Fetch doctor list for Doctor Availability
  useEffect(() => {
    fetchDoctors();
  }, []);
  const fetchDoctors = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    try {
      const response = await fetch(
        `${API_URL}doctor/list?clinicId=${tenantId}`,
        {
          headers: { Authorization: `Bearer ${token}`, tenantId: tenantId },
        }
      );
      const data = await response.json();
      setDoctorList(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching doctor list:", error);
    }
  };

  // Get unique specializations from doctor list
  const getUniqueSpecializations = () => {
    const specializations = new Set();
    doctorList.forEach((doctor) => {
      if (Array.isArray(doctor.specialization)) {
        doctor.specialization.forEach((spec) => {
          specializations.add(spec);
        });
      }
    });
    return Array.from(specializations).sort();
  };

  // Helper function to get delay information from doctor's timeSlots
  const getDoctorDelay = (doctor) => {
    if (!Array.isArray(doctor.timeSlots)) return null;
    
    const today = new Date();
    const days = [
      "Sunday",
      "Monday", 
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ];
    const currentDayOfWeek = days[today.getDay()];
    
    const todaySlot = doctor.timeSlots.find(
      (slot) => (slot.dayOfWeek || "").toUpperCase() === currentDayOfWeek.toUpperCase()
    );
    
    return todaySlot?.delayByMinutes || null;
  };
  const handledelayed = async (doctor, reset) => {
    setDoctordata(doctor);
    setResetstatus(reset);
    setIsdelayedOpen(true);
  };
  const handleclosesidebar = () => {
    setIsdelayedOpen(false);
  };

  const handleArrived = async (doctor) => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const delayInMinutes = 0; // Set delay to 0 for arrived status

    if (!doctor.doctorCode) {
      toast.error("Please select a doctor.");
      return;
    }

    const today = new Date();
    const formattedDate = format(today, "yyyy-MM-dd");

    // Calculate the day of week for today (lowercase format)
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const currentDayOfWeek = days[today.getDay()];

    // Get doctor's time slots for today
    let startTime = "";
    let endTime = "";
    if (Array.isArray(doctor.timeSlots)) {
      const todaySlot = doctor.timeSlots.find(
        (slot) =>
          (slot.dayOfWeek || "").toUpperCase() ===
          currentDayOfWeek.toUpperCase()
      );
      if (todaySlot) {
        startTime = todaySlot.startTime || "";
        endTime = todaySlot.endTime || "";
      }
    }

    const apiUrl = `${API_URL}queue/appointment/delay?doctorId=${doctor.doctorCode}&whenAppointment=${formattedDate}&dayOfWeek=${currentDayOfWeek}&delayInMinutes=${delayInMinutes}&startTime=${startTime}&endTime=${endTime}&isReset=true&clinicId=${tenantId}`;

    try {
      const res = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      });

      const contentType = res.headers.get("content-type");

      let result;
      if (contentType && contentType.includes("application/json")) {
        result = await res.json();
      } else {
        result = await res.text();
      }

      console.log("Response:", result);
      toast.success(result.message || "Doctor status updated successfully");
      fetchDoctors(); // Refresh the doctor list
    } catch (error) {
      console.error("Error updating doctor status:", error);
      toast.error("Something went wrong while updating doctor status.");
    }
  };

  const handleConfirmDelay = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const delayInMinutes = selectedHour
      ? selectedHour * 60 + (selectedMinute || 0)
      : (selectedMinute || 0);
console.log(delayInMinutes,"delayInMinutes")
    if (!doctordata.doctorCode) {
      toast.error("Please select a doctor.");
      return;
    }
    if (!fromTime || !toTime) {
      toast.error("Please select Select Time Slot.");
      return;
    }
    
    if (!delayInMinutes || delayInMinutes <= 0) {
      toast.error("Please enter a valid delay duration.");
      return;
    }
    const today = new Date();
    const formattedDate = format(today, "yyyy-MM-dd");
    const apiUrl = `${API_URL}queue/appointment/delay?doctorId=${doctordata.doctorCode}&whenAppointment=${formattedDate}&delayInMinutes=${delayInMinutes}&dayOfWeek=${dayofweek}&startTime=${fromTime}&endTime=${toTime}&isReset=${resetstatus}&clinicId=${tenantId}`;
    console.log(apiUrl, "apiUrl");
    try {
      const res = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      });

      const contentType = res.headers.get("content-type");

      let result;
      if (contentType && contentType.includes("application/json")) {
        result = await res.json();
      } else {
        result = await res.text();
      }
      setSelectedMinute();
      setSelectedHour();
      setDayofweek();

      console.log("Response:", result);
      toast.success(result.message);
      setIsdelayedOpen(false);
      fetchDoctors();
      // if (res.ok && result.trim() === "Estimated times updated successfully.") {
      //   toast.success(result.message);
      // } else {
      //   toast.error(result?.message || result || "Failed to update delay");
      // }
    } catch (error) {
      console.error("Error confirming delay:", error);
      toast.error("Something went wrong while confirming delay.");
    }
  };
  useEffect(() => {
    fetchpathologyOrders();
    fetchMedOrders();
    fetchradiologyOrders();
  }, []);
  async function fetchpathologyOrders() {
    // setLoading(true);
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const today = new Date().toISOString().split("T")[0];
    const clinicId = localStorage.getItem("clinicId");
    try {
      const resp = await axios.get(
        `${API_URL}orders?orderType=lab&subServiceType=pathology&clinicId=${clinicId}&fromDate=${today}&toDate=${today}`,
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      setpathologyOrders(resp.data.records || []);
      //console.log(resp.data.records, "hhkjhjkh");
    } catch (err) {
      console.error("Fetch error:", err.response || err);
    } finally {
      // setLoading(false);
    }
  }
  async function fetchradiologyOrders() {
    // setLoading(true);
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const today = new Date().toISOString().split("T")[0];
    const clinicId = localStorage.getItem("clinicId");
    try {
      const resp = await axios.get(
        `${API_URL}orders?orderType=lab&subServiceType=radiology&clinicId=${clinicId}&fromDate=${today}&toDate=${today}`,
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      setradiologyOrders(resp.data.records || []);
      //console.log(resp.data.records, "hhkjhjkh");
    } catch (err) {
      console.error("Fetch error:", err.response || err);
    } finally {
      // setLoading(false);
    }
  }
  // http://localhost:8095/smartclinic/orders?orderType=lab&subServiceType=pathology&patientId=NODWC6476P

  async function fetchMedOrders() {
    // setLoading(true);
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const today = new Date().toISOString().split("T")[0];
    const clinicId = localStorage.getItem("clinicId");
    try {
      const resp = await axios.get(
        `${API_URL}orders?orderType=pharmacy&clinicId=${clinicId}&fromDate=${today}&toDate=${today}`,
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      setmedOrders(resp.data.records || []);
      console.log(resp.data.records, "fhgfhfhjgjh");
    } catch (err) {
      console.error("Fetch error:", err.response || err);
    } finally {
      // setLoading(false);
    }
  }

  const handleSearch = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const input = searchInput.trim();

    const isMobile = /^[0-9]+$/.test(input);
    const searchParam = isMobile
      ? `mobileNumber=${input}`
      : `firstName=${input}`;

    const url = `${API_URL}patient/search?${searchParam}`;

    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      });

      const data = await res.json();
console.log(data.data,"ftghjkl")
      if (Array.isArray(data?.data)) {
        setSearchResults(data?.data);
      } else {
        setSearchResults([]);
        // toast.error("No patient found.");
      }
    } catch (error) {
      console.error("Search error:", error);
      toast.error("Something went wrong while searching.");
    }
  };

  const handleCloseReschedule = () => {
    setIsRescheduleOpen(false);
    setSelectedToken("");
    setSelectedappointmentid("");
    setSelectedSlot("");
    setSelecteddoctorid("");
    // Optionally refresh ongoing patients here if needed
  };

  // ABHA Status Check Function
  const isAbhaVerified = (patient) => {
    return patient.abhaNumber && patient.preferredAbhaAddress;
  };

  const handleAbhaVerify = (patient) => {
    setSelectedPatientForAbha(patient);
    setIsAbhaVerifyOpen(true);
  };

  const handleAbhaCreate = (patient) => {
    setSelectedPatientForAbha(patient);
    setIsAbhaCreateOpen(true);
  };

  const handleAbhaSuccess = async (abhaData) => {
    try {
      // Parse ABHA data from verification/creation responses
      let abhaNumber = "";
      let preferredAbhaAddress = "";

      if (abhaData?.abhaProfile) {
        abhaNumber = abhaData.abhaProfile.abhaNumber || "";
        preferredAbhaAddress = abhaData.abhaProfile.preferredAbhaAddress || "";
      } else if (abhaData?.healthIdNumber) {
        abhaNumber = abhaData.healthIdNumber || "";
        preferredAbhaAddress = abhaData.preferredAbhaAddress || "";
      }

      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");

      if (selectedPatientForAbha?.patientCode) {
        const updatePayload = {
          firstName: selectedPatientForAbha.firstName,
          lastName: selectedPatientForAbha.lastName,
          gender: selectedPatientForAbha.gender,
          mobileNumber: selectedPatientForAbha.mobileNumber,
          abhaNumber: abhaNumber,
          preferredAbhaAddress: preferredAbhaAddress,
        };

        const res = await fetch(
          `${API_URL}patient/update/${selectedPatientForAbha.patientCode}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              tenantId: tenantId,
            },
            body: JSON.stringify(updatePayload),
          }
        );

        if (res.ok) {
          toast.success("Patient ABHA information updated successfully!");
        } else {
          try {
            const data = await res.json();
            toast.error(data?.message || "Failed to update patient ABHA information");
          } catch (_) {
            toast.error("Failed to update patient ABHA information");
          }
        }
      }
    } catch (error) {
      console.error("Error updating patient ABHA information:", error);
      toast.error("Failed to update patient ABHA information");
    } finally {
      setIsAbhaVerifyOpen(false);
      setIsAbhaCreateOpen(false);
      setSelectedPatientForAbha(null);
      // Refresh search results to show updated ABHA status
      if (searchInput.trim().length >= 3) {
        handleSearch();
      }
    }
  };

  const handleAbhaClose = () => {
    setIsAbhaVerifyOpen(false);
    setIsAbhaCreateOpen(false);
    setSelectedPatientForAbha(null);
  };
  const handleSkip = async (patient) => {
    const token = localStorage.getItem("auth_token");
    console.log(patient, "wserdtfyguh");

    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${yyyy}-${mm}-${dd}`;
    try {
      const res = await fetch(
        `${API_URL}queue/skip?doctorId=${patient.doctorId}&date=${formattedDate}&appointmentId=${patient.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.ok) {
        toast.success("Patient skipped successfully.");
        fetchOngoingPatients();
      } else {
        const data = await res.json();
        const msg = data?.message || "Failed to skip the patient.";
        toast.error(msg);
      }
    } catch (err) {
      console.error("Skip error:", err);
      toast.error("Something went wrong while skipping.");
    }
  };

  const handleSendKavachLink = async (user) => {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      toast.error("Please login to send Kavach link.");
      return;
    }

    const mobileNumber = String(user.mobileNumber || "").replace(/\D/g, "");
    if (!/^\d{10}$/.test(mobileNumber)) {
      toast.error("Valid 10-digit mobile number is required.");
      return;
    }

    const patientName = [user.firstName, user.lastName]
      .filter(Boolean)
      .join(" ")
      .trim();
    if (!patientName) {
      toast.error("Patient name is required.");
      return;
    }

    if (!hospitalid) {
      toast.error("Hospital ID not found.");
      return;
    }

    try {
      setSendingKavachCode(user.patientCode);
      const res = await fetch(`${API_URL}curebayKavach/send-link`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          mobileNumber,
          patientName,
          hospitalId: hospitalid,
        }),
      });

      if (res.ok) {
        toast.success("Kavach link sent successfully.");
        return;
      }

      let msg = "Failed to send Kavach link.";
      try {
        const data = await res.json();
        msg = data?.message || data?.error || msg;
      } catch (_) {
        /* ignore parse errors */
      }
      toast.error(msg);
    } catch (err) {
      console.error("Send Kavach link error:", err);
      toast.error("Something went wrong while sending Kavach link.");
    } finally {
      setSendingKavachCode(null);
    }
  };

  const handleSendQuantumLink = async (user) => {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      toast.error("Please login to send Quantum link.");
      return;
    }

    const baseUrl = getHealthSessionBaseUrl();
    if (!baseUrl) {
      toast.error(
        "Health session URL is not configured. Set REACT_APP_HEALTH_SESSION_URL and restart the app."
      );
      return;
    }

    const patientId = user.curebayPatientId;
    if (!patientId) {
      toast.error("CureBay patient ID not found for this patient.");
      return;
    }

    const mobileNumber = String(user.mobileNumber || "").replace(/\D/g, "");
    if (!/^\d{10}$/.test(mobileNumber)) {
      toast.error("Valid 10-digit mobile number is required.");
      return;
    }

    const patientName = [user.firstName, user.lastName]
      .filter(Boolean)
      .join(" ")
      .trim();
    if (!patientName) {
      toast.error("Patient name is required.");
      return;
    }

    try {
      setSendingQuantumCode(user.patientCode);

      const sessionRes = await fetch(`${baseUrl}/aes-sessions`, {
        method: "POST",
        headers: {
          accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          patientId,
          isActive: true,
          sourceChannel: "D2C",
        }),
      });

      let sessionData = {};
      try {
        sessionData = await sessionRes.json();
      } catch (_) {
        /* ignore empty or non-JSON body */
      }

      if (!sessionRes.ok) {
        const msg =
          sessionData?.message ||
          sessionData?.error ||
          "Failed to create health session.";
        toast.error(msg);
        return;
      }

      const sessionId = sessionData?.sessionId;
      if (!sessionId) {
        toast.error("Session ID not returned from health session API.");
        return;
      }

      const sendLinkRes = await fetch(`${API_URL}upscale/quantum/send-link`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          mobileNumber,
          patientName,
          sessionId,
        }),
      });

      let sendLinkData = {};
      try {
        sendLinkData = await sendLinkRes.json();
      } catch (_) {
        /* ignore empty or non-JSON body */
      }

      if (sendLinkRes.ok) {
        toast.success("Quantum link sent successfully.");
        return;
      }

      const msg =
        sendLinkData?.message ||
        sendLinkData?.error ||
        "Failed to send Quantum link.";
      toast.error(msg);
    } catch (err) {
      console.error("Send Quantum link error:", err);
      toast.error("Something went wrong while sending Quantum link.");
    } finally {
      setSendingQuantumCode(null);
    }
  };

  const handleExploreQuantum = () => {
    const url = getQuantumUrl();
    if (!url) {
      toast.error(
        "Quantum URL is not configured. Set REACT_APP_QUANTUM_URL and restart the app."
      );
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const SearchResultMobileCard = ({ user, idx }) => (
    <div className="border-b border-gray-200 pb-4 last:border-b-0">
      <div className="flex justify-between items-start mb-2">
        <div className="flex-1">
          <h3 className="font-medium text-gray-900 capitalize text-sm">
            {user.firstName} {user.lastName}
          </h3>
          <p className="text-sm text-gray-600 mt-1">{user.mobileNumber}</p>
          <p className="text-sm text-gray-600">Age: {user.age}</p>

          {/* ABHA Status Section */}
          {!disabledFeatures.includes("ABDM") && (
          <div className="mt-4">
            {isAbhaVerified(user) ? (
              <div className="relative overflow-hidden bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 border border-green-200/60 rounded-xl p-4 shadow-sm hover:shadow-md transition-all duration-300">
                {/* Background Pattern */}
                <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-br from-green-200/20 to-transparent rounded-full -translate-y-8 translate-x-8"></div>

                <div className="relative flex items-center gap-4">
                  <div className="flex items-center justify-center w-10 h-10 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full shadow-lg">
                    <svg
                      className="w-5 h-5 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-sm font-bold text-green-800 tracking-wide">
                        ABHA Verified
                      </span>
                    </div>
                    <div className="bg-white/70 backdrop-blur-sm border border-green-200/50 rounded-lg px-3 py-2">
                      <div className="text-xs text-green-700 font-mono font-semibold tracking-wider">
                        {user.abhaNumber}
                      </div>
                      <div className="text-xs text-green-600 mt-1 opacity-75">
                        Health ID Ready
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="relative overflow-hidden bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 border border-orange-200/60 rounded-xl p-4 shadow-sm hover:shadow-md transition-all duration-300">
                {/* Background Pattern */}
                <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-br from-orange-200/20 to-transparent rounded-full -translate-y-8 translate-x-8"></div>

                <div className="relative flex items-center gap-4">
                  <div className="flex items-center justify-center w-10 h-10 bg-gradient-to-br from-orange-400 to-red-500 rounded-full shadow-lg">
                    <svg
                      className="w-5 h-5 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-sm font-bold text-orange-800 tracking-wide">
                        ABHA Not Verified
                      </span>
                    </div>
                    <button
                      onClick={() => handleAbhaVerify(user)}
                      className="group relative bg-gradient-to-r from-blue-500 via-blue-600 to-indigo-600 hover:from-blue-600 hover:via-blue-700 hover:to-indigo-700 text-white text-xs font-semibold px-4 py-2.5 rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-lg shadow-md"
                    >
                      <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-indigo-500 rounded-xl opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                      <div className="relative flex items-center gap-2">
                        <svg
                          className="w-4 h-4"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <span>Verify ABHA</span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          )}
        </div>
      </div>
      <div className="flex gap-2 mt-3">
        <button
          className="flex-1 text-xs py-2 px-3 text-green-600 bg-green-50 rounded-md hover:bg-green-100 transition-colors"
          onClick={() =>
            navigate("/Patientregister", {
              state: {
                parentCode: user.patientCode,
                mobileNumber: user.mobileNumber,
              },
            })
          }
        >
          +Add Member
        </button>
        <button
          className="flex-1 text-xs py-2 px-3 text-white bg-[#004276] rounded-md hover:bg-[#003661] transition-colors"
          onClick={() =>
            navigate("/BookServicescard", {
              state: { patientCode: user.patientCode, patientcbcode: user.curebayPatientId, patient: user  },
            })
          }
        >
          Book
        </button>
      </div>
    </div>
  );

  <div className="bg-[#004276] text-white px-4 py-3 rounded-md mb-3">
    <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
      <h2 className="text-lg font-semibold flex items-center gap-2 mb-0">
        <img src={patientvectoricon} alt="Patient" className="w-5 h-5" />
        Searching for a Patient?
      </h2>

      <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center w-full lg:w-auto">
        {/* Search Input */}
        <div className="relative flex-1 sm:min-w-[200px] lg:min-w-[250px]">
          <input
            type="text"
            placeholder="Search by Name / Mobile"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            className="rounded px-4 py-2 text-black w-full pr-10 text-sm"
          />
          <button className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
            <img src={searchicon} alt="Search" className="w-4 h-4" />
          </button>
        </div>

        {/* Register Button */}
        {/* <button
                    className="bg-[#00BD7F] hover:bg-[#019a75] px-4 sm:px-6 py-2 text-sm rounded-full font-medium whitespace-nowrap transition-colors"
                    onClick={() => navigate("/Patientregister")}
                  >
                    + Register Patient
                  </button> */}
      </div>
    </div>
  </div>;

  {
    /* Search Results - Responsive */
  }
  {
    searchResults.length > 0 && (
      <div className="mt-4 mb-3 bg-white border border-gray-300 rounded-md shadow-sm overflow-hidden">
        {viewMode === "mobile" ? (
          // Mobile View - Cards
          <div className="p-4 space-y-4">
            {searchResults.map((user, idx) => (
              <SearchResultMobileCard key={idx} user={user} idx={idx} />
            ))}
          </div>
        ) : (
          // Tablet & Desktop View - Table
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-100 text-gray-700 font-semibold">
                <tr>
                  <th className="p-2 text-left">Name</th>
                  <th className="p-2 text-left">Phone Number</th>
                  <th className="p-2 text-left">Age</th>
                  {!disabledFeatures.includes("ABDM") && (
                    <th className="p-2 text-left">ABHA Status</th>
                  )}
                  <th className="p-2 text-left">Add Family</th>
                  <th className="p-2 text-left">Book Services</th>
                  <th className="p-2 text-left">View Details</th>
                  <th className="p-2 text-left">Share</th>
                 
                </tr>
              </thead>
              <tbody>
                {searchResults.map((user, idx) => (
                  <tr key={idx} className="border-t">
                    <td className="p-2 capitalize">
                      {user.firstName} {user.lastName}
                    </td>
                    <td className="p-2">{user.mobileNumber}</td>
                    <td className="p-2">{user.age}</td>
                    {!disabledFeatures.includes("ABDM") && (
                      <td className="p-2">
                      {isAbhaVerified(user) ? (
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                          <span className="text-xs text-green-600 font-medium">
                            Verified
                          </span>
                          <div
                            className="text-xs text-gray-500 truncate max-w-[120px]"
                            title={user.abhaNumber}
                          >
                            {user.abhaNumber}
                          </div>
                        </div>
                      ) : (
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                          <span className="text-xs text-red-600 font-medium">
                            Not Verified
                          </span>
                          <button
                            onClick={() => handleAbhaVerify(user)}
                            className="text-xs text-blue-600 hover:text-blue-800 underline"
                          >
                            Create ABHA
                          </button>
                        </div>
                      )}
                      </td>
                    )}
                    <td
                      className="p-2 text-green-600 cursor-pointer hover:underline"
                      onClick={() =>
                        navigate("/Patientregister", {
                          state: {
                            parentCode: user.patientCode,
                            mobileNumber: user.mobileNumber,
                          },
                        })
                      }
                    >
                      +Add Member
                    </td>
                    <td className="p-2">
                      <button
                        type="button"
                        className={`${patientSearchActionBtn} px-5 py-2 text-white cursor-pointer shadow-[0_2px_8px_rgba(10,76,138,0.25)]`}
                        style={{
                          background:
                            "linear-gradient(90deg, #0A4C8A 0%, #00B58F 100%)",
                        }}
                        onClick={() =>
                          navigate("/BookServicescard", {
                            state: {
                              patientCode: user.patientCode,
                              patientcbcode: user.curebayPatientId,
                              patient: user,
                            },
                          })
                        }
                      >
                        <Calendar className="h-4 w-4 shrink-0" strokeWidth={2.5} />
                        Book
                      </button>
                    </td>
                    <td className="p-2">
                      <button
                        type="button"
                        className={`${patientSearchActionBtn} cursor-pointer p-[2px] bg-gradient-to-r from-[#0A4C8A] to-[#00B58F]`}
                        onClick={() =>
                          navigate("/PatientDetails", {
                            state: { patientCode: user.patientCode, curebayPatientId: user.curebayPatientId },
                          })
                        }
                      >
                        <span className="inline-flex w-full items-center justify-center gap-2 rounded-[10px] bg-white px-5 py-2 text-[#0A7A6E]">
                          <Eye className="h-4 w-4 shrink-0" strokeWidth={2.5} />
                          View
                        </span>
                      </button>
                    </td>
                    <td className="p-2">
                      <button
                        type="button"
                        className={`${patientSearchActionBtn} px-5 py-2 cursor-pointer border border-[#D1D9E6] bg-white text-[#5B6B7C] hover:bg-[#F8FAFC] disabled:opacity-60 disabled:cursor-not-allowed`}
                        onClick={() => handleSendKavachLink(user)}
                        disabled={sendingKavachCode === user.patientCode}
                      >
                        <Share2
                          className="h-4 w-4 shrink-0 text-[#0A8A8F]"
                          strokeWidth={2.5}
                        />
                        {sendingKavachCode === user.patientCode
                          ? "Sending..."
                          : "Share"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }
  {
    searchInput.trim().length >= 3 && searchResults.length == 0 && (
      <div className="mt-4 bg-white border border-gray-300 rounded-md shadow-sm overflow-hidden">
        <div className="flex flex-col items-center justify-center text-center py-6 space-y-4">
          <p className="text-gray-700">
            We couldn't find this patient in our system. Let's get them
            registered to continue.
          </p>
            <button
              className="bg-[#00BD7F] hover:bg-[#019a75] px-6 py-2 text-sm text-white rounded-full font-medium whitespace-nowrap transition-colors"
              onClick={() => navigate("/Patientregister", { state: { mobileNumber: (searchInput || "").replace(/[^0-9]/g, "") } })}
            >
            + Register Patient
          </button>
        </div>
      </div>
    );
  }

  const DoctorAvailabilitySection = ({
    doctorAvailabilityDate,
    setDoctorAvailabilityDate,
    selectedSpecialization,
    setSelectedSpecialization,
  }) => {
    // Helper to get day of week from date string (yyyy-MM-dd)
    function getDayOfWeek(dateStr) {
      const days = [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY",
      ];
      const d = new Date(dateStr);
      return days[d.getDay()];
    }
    const selectedDay = getDayOfWeek(doctorAvailabilityDate);

    return (
      <div className="h-full flex flex-col">
        {/* Header with title and count badge */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-[#004276]">
            Doctor Availability
            <span className="bg-[#00BD7F] text-white font-medium px-2 py-1 rounded-md text-sm ml-1">
              {
                doctorList.filter(
                  (doctor) =>
                    doctor.userActive === "active" &&
                    Array.isArray(doctor.timeSlots) &&
                    doctor.timeSlots.some(
                      (slot) =>
                        (slot.dayOfWeek || "").toUpperCase() === selectedDay
                    ) &&
                    (selectedSpecialization === "" ||
                      (Array.isArray(doctor.specialization) &&
                        doctor.specialization.includes(selectedSpecialization)))
                ).length
              }
            </span>
          </h2>
          <div className="flex gap-3">
            <select
              className="w-[146px] h-[35px] px-[0.4rem] py-2 text-sm text-gray-500 border-[0.5px] border-[#C6C6C6] rounded-md focus:outline-none"
              value={selectedSpecialization}
              onChange={(e) => setSelectedSpecialization(e.target.value)}
            >
              <option value="">All Specialities</option>
              {getUniqueSpecializations().map((spec, index) => (
                <option key={index} value={spec}>
                  {spec}
                </option>
              ))}
            </select>
            <input
              type="date"
              className="w-[146px] h-[35px] px-[0.4rem] py-2 text-sm text-gray-500 border-[0.5px] border-[#C6C6C6] rounded-md focus:outline-none"
              value={doctorAvailabilityDate}
              onChange={(e) => setDoctorAvailabilityDate(e.target.value)}
            />
          </div>
        </div>
        {/* Main content container with fixed height */}
        <div className="bg-white rounded-lg shadow-[0px_4px_8px_rgba(0,0,0,0.15)] h-[400px] flex flex-col">
          {doctorList.filter(
            (doctor) =>
              doctor.userActive === "active" &&
              Array.isArray(doctor.timeSlots) &&
              doctor.timeSlots.some(
                (slot) => (slot.dayOfWeek || "").toUpperCase() === selectedDay
              ) &&
              (selectedSpecialization === "" ||
                (Array.isArray(doctor.specialization) &&
                  doctor.specialization.includes(selectedSpecialization)))
          ).length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-gray-500 py-8">
              <img src={nodata} alt="No Data" className="w-48 h-48 mb-4" />
              <div>No doctors available</div>
            </div>
          ) : (
            <div className="h-full overflow-y-auto">
              {doctorList
                .filter(
                  (doctor) =>
                    doctor.userActive === "active" &&
                    Array.isArray(doctor.timeSlots) &&
                    doctor.timeSlots.some(
                      (slot) =>
                        (slot.dayOfWeek || "").toUpperCase() === selectedDay
                    ) &&
                    (selectedSpecialization === "" ||
                      (Array.isArray(doctor.specialization) &&
                        doctor.specialization.includes(selectedSpecialization)))
                )
                .map((doctor, index) => {
                  const slotsForDay = doctor.timeSlots.filter(
                    (slot) =>
                      (slot.dayOfWeek || "").toUpperCase() === selectedDay
                  );
                  return (
                    <div
                      key={doctor.id || index}
                      className="flex items-center justify-between px-5 py-3 border-b last:border-none"
                    >
                      <div className="flex items-center gap-3">
                        <img
                          src={
                            doctor.avatar ||
                            "https://cdn-icons-png.flaticon.com/512/3774/3774299.png"
                          }
                          alt={doctor.fullName}
                          className="w-10 h-10 rounded-full object-cover"
                          onError={(e) =>
                            (e.target.src =
                              "https://cdn-icons-png.flaticon.com/512/3774/3774299.png")
                          }
                        />
                        <div>
                          <h3 className="font-semibold text-sm text-[#212529]">
                            Dr. {doctor.fullName}&nbsp;(
                            {Array.isArray(doctor.specialization)
                              ? doctor.specialization.join(", ")
                              : doctor.specialization}
                            )
                          </h3>
                          <p className="text-sm text-gray-600 mb-0">
                            Mobile Number: {doctor.phoneNumber}
                          </p>
                          {/* Working Hours for selected day */}
                          <div className="text-xs text-gray-600 mt-1">
                            {slotsForDay.map((slot, idx) => (
                              <div key={idx}>
                                <span className="font-medium">
                                  {slot.dayOfWeek}:
                                </span>{" "}
                                {slot.startTime} - {slot.endTime} {slot.delayByMinutes ? ` (${slot.delayByMinutes} delay)` : ""}
                              </div>
                            ))}
                          </div>
                          <p className="text-sm text-gray-600">
                            Status:{" "}
                            {doctor.doctorStatus == "Delayed" ? (
                              <span className="font-semibold text-sm text-[#D76C0C]">
                                {doctor.doctorStatus}
                                {getDoctorDelay(doctor) && (
                                  <span className="ml-1 text-xs">
                                    ({getDoctorDelay(doctor)})
                                  </span>
                                )}
                              </span>
                            ) : (
                              <span className="font-semibold text-sm text-green-600">
                                {doctor.doctorStatus}
                              </span>
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="text-right">
                        {/* <p className="text-sm text-gray-600">
                          {getTodayDate()}
                        </p> */}
                        {doctor.doctorStatus == "Delayed" ? (
                          <button
                            onClick={() => handleArrived(doctor)}
                            className="bg-white text-[#003F74] border border-[#003F74] text-xs px-4 py-1 rounded-full font-medium"
                          >
                            Arrived
                          </button>
                        ) : (
                          <button
                            onClick={() => handledelayed(doctor, false)}
                            className="bg-[#003F74] text-white text-xs px-4 py-1 rounded-full font-medium"
                          >
                            Delayed
                          </button>
                        )}
                        {/* Add delay/arrived buttons if needed */}
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
      </div>
    );
  };

  const OngoingPatientSection = () => (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-[#004276]">
          Ongoing Patient{" "}
          <span className="bg-[#00BD7F] text-white font-medium px-2 py-1 rounded-md text-sm ml-1">
            {ongoingPatients.length}
          </span>
        </h2>
        {ongoingPatients.length !== 0 && (
          <button
            className="text-[#00BD7F] text-sm font-semibold hover:underline"
            onClick={() => navigate("/QueueManagement")}
          >
            View All
          </button>
        )}
      </div>
      {/* Cards Grid with flex-1 to fill remaining space */}
      <div className="grid grid-cols-2 gap-4 flex-1">
        {ongoingPatients.map((patient) => (
          <div
            key={patient.id}
            className="rounded-md border border-[#86EFAC] p-4 bg-gradient-to-b from-[#DDFCE8] to-white h-fit"
          >
            {/* Top Row */}
            <div className="flex justify-between items-center mb-3">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-[#00B58D] rounded-full"></span>
                <span className="text-sm text-[#212529] font-medium">
                  Token: <span className="font-bold">{patient.token}</span>
                </span>
              </div>
              <span className="px-3 py-0.5 text-sm font-medium border border-[#00B58D] text-[#00B58D] rounded-full">
                {patient.status}
              </span>
            </div>
            {/* Info Row */}
            <div className="grid grid-cols-2 text-sm text-[#212529] mb-1">
              <div>
                <p className="text-gray-500 mb-1">Patient Name:</p>
                <p className="font-medium">{patient.patient}</p>
              </div>
              <div>
                <p className="text-gray-500 mb-1">Doctor Name:</p>
                <p className="font-medium">{patient.doctor}</p>
              </div>
            </div>
            <div>
              <p className=" text-gray-500 text-sm ">
                Slot Time:
                <span className="text-sm font-medium text-[#000]">
                  &nbsp;{patient.slot}
                </span>
              </p>
            </div>
            {/* Reschedule Button */}
            <div className="flex justify-end">
              <button
                className="text-xs cursor-pointer text-orange-500 border border-orange-300 px-3 py-1 rounded-full font-medium flex items-center gap-1"
                onClick={() => {
                  handleSkip(patient);
                  // setSelectedToken(patient.token);
                  // setSelectedappointmentid(patient.idskip);
                  // setSelectedSlot("");
                  // setRescheduleDate(new Date());
                  // setIsRescheduleOpen(true);
                  // setSelecteddoctorid(patient.doctorId);
                }}
              >
                <span>⏭</span> Skip
              </button>
            </div>
            {/* <div className="flex justify-end">
              <button
                className="text-xs text-orange-500 border border-orange-300 px-3 py-1 rounded-full font-medium flex items-center gap-1"
                onClick={() => {
                  setSelectedToken(patient.token);
                  setSelectedappointmentid(patient.id);
                  setSelectedSlot("");
                  setRescheduleDate(new Date());
                  setIsRescheduleOpen(true);
                  setSelecteddoctorid(patient.doctorId);
                }}
              >
                <span>⏭</span> Reschedule
              </button>
            </div> */}
          </div>
        ))}
        {ongoingPatients.length === 0 && (
          <div className="bg-white rounded-lg shadow-[0px_4px_8px_rgba(0,0,0,0.15)] flex-1 flex flex-col col-span-2 text-center text-gray-500 py-16">
            <img
              src={noongoing}
              alt="No Patients"
              className="mx-auto h-48 w-48 "
            />
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      <OurLayouts>
        <div className="min-h-screen p-4">
          <div className="max-w-6xl mx-auto">
            {/* EXACT 2x3 LAYOUT - 2 COLUMNS, 3 ROWS */}
            <div className="bg-[#004276] text-white px-4 py-3 rounded-md mb-3">
              <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
                <h2 className="text-lg font-semibold flex items-center gap-2 mb-0">
                  <img
                    src={patientvectoricon}
                    alt="Patient"
                    className="w-5 h-5"
                  />
                  Searching for a Patient?
                </h2>

                <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center w-full lg:w-auto">
                  {/* Search Input */}
                  <div className="relative flex-1 sm:min-w-[200px] lg:min-w-[250px]">
                    <input
                      type="text"
                      placeholder="Search by Name / Mobile"
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                      className="rounded px-4 py-2 text-black w-full pr-10 text-sm"
                    />
                    <button className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                      <img src={searchicon} alt="Search" className="w-4 h-4" />
                    </button>
                  </div>

                  {/* Register Button */}
                  {/* <button
                    className="bg-[#00BD7F] hover:bg-[#019a75] px-4 sm:px-6 py-2 text-sm rounded-full font-medium whitespace-nowrap transition-colors"
                    onClick={() => navigate("/Patientregister")}
                  >
                    + Register Patient
                  </button> */}
                </div>
              </div>
            </div>

            {/* Search Results - Responsive */}
            {searchResults.length > 0 && (
              <div className="mt-4 mb-3 bg-white border border-gray-300 rounded-md shadow-sm overflow-hidden">
                {viewMode === "mobile" ? (
                  // Mobile View - Cards
                  <div className="p-4 space-y-4">
                    {searchResults.map((user, idx) => (
                      <SearchResultMobileCard key={idx} user={user} idx={idx} />
                    ))}
                  </div>
                ) : (
                  // Tablet & Desktop View - Table
                  <div className="overflow-x-auto relative">
                    <ShareLinkGradientDefs />
                    <table className="min-w-full text-sm">
                      <thead className="bg-gray-100 text-gray-700 font-semibold">
                        <tr>
                          <th className="p-2 text-left">Name</th>
                          <th className="p-2 text-left">Phone Number</th>
                          <th className="p-2 text-left">Age</th>
                          {!disabledFeatures.includes("ABDM") && (
                          <th className="p-2 text-left">ABHA Status</th>
                          )}
                          <th className="p-2 text-left">Add Family</th>
                          <th className="p-2 text-left">Book Services</th>
                          <th className="p-2 text-left">View Details</th>
                          <th className="p-2 text-left">Share Link</th>
                        </tr>
                      </thead>
                      <tbody>
                        {searchResults.map((user, idx) => (
                          <tr key={idx} className="border-t">
                            <td className="p-2 capitalize">
                              {user.firstName} {user.lastName}
                            </td>
                            <td className="p-2">{user.mobileNumber}</td>
                            <td className="p-2">{user.age}</td>
                            {!disabledFeatures.includes("ABDM") && (
                            <td className="p-2">
                              {isAbhaVerified(user) ? (
                                <div className="relative overflow-hidden bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 border border-green-200/60 rounded-lg p-3 shadow-sm hover:shadow-md transition-all duration-300">
                                  {/* Background Pattern */}
                                  <div className="absolute top-0 right-0 w-8 h-8 bg-gradient-to-br from-green-200/20 to-transparent rounded-full -translate-y-4 translate-x-4"></div>

                                  <div className="relative flex items-center gap-3">
                                    <div className="flex items-center justify-center w-8 h-8 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full shadow-md">
                                      <svg
                                        className="w-4 h-4 text-white"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                    <div className="flex-1 min-w-0">
                                      <div className="flex items-center gap-2 mb-1.5">
                                        <span className="text-xs font-bold text-green-800 tracking-wide">
                                          Verified
                                        </span>
                                      </div>
                                      <div className="bg-white/70 backdrop-blur-sm border border-green-200/50 rounded px-2 py-1.5">
                                        <div
                                          className="text-xs text-green-700 font-mono font-semibold tracking-wider truncate"
                                          title={user.abhaNumber}
                                        >
                                          {user.abhaNumber}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="relative overflow-hidden bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 border border-orange-200/60 rounded-lg p-3 shadow-sm hover:shadow-md transition-all duration-300">
                                  {/* Background Pattern */}
                                  <div className="absolute top-0 right-0 w-8 h-8 bg-gradient-to-br from-orange-200/20 to-transparent rounded-full -translate-y-4 translate-x-4"></div>

                                  <div className="relative flex items-center gap-3">
                                    <div className="flex items-center justify-center w-8 h-8 bg-gradient-to-br from-orange-400 to-red-500 rounded-full shadow-md">
                                      <svg
                                        className="w-4 h-4 text-white"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                    <div className="flex-1 min-w-0">
                                      <div className="flex items-center gap-2 mb-2">
                                        <span className="text-xs font-bold text-orange-800 tracking-wide">
                                          Not Verified
                                        </span>
                                      </div>
                                      <button
                                        onClick={() => handleAbhaVerify(user)}
                                        className="group relative bg-gradient-to-r from-blue-500 via-blue-600 to-indigo-600 hover:from-blue-600 hover:via-blue-700 hover:to-indigo-700 text-white text-xs font-semibold px-3 py-1.5 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-md shadow-sm"
                                      >
                                        <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-indigo-500 rounded-lg opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                                        <div className="relative flex items-center gap-1.5">
                                          <svg
                                            className="w-3 h-3"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                              clipRule="evenodd"
                                            />
                                          </svg>
                                          <span>Verify ABHA</span>
                                        </div>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </td>
                            )}
                            {!user.parentCode && (
                              <td
                                className="p-2 text-green-600 cursor-pointer hover:underline"
                                onClick={() =>
                                  navigate("/Patientregister", {
                                    state: {
                                      parentCode: user.patientCode,
                                      mobileNumber: user.mobileNumber,
                                    },
                                  })
                                }
                              >
                                +Add Member
                              </td>
                            )}
                            {user.parentCode && (
                              <td className="p-2 text-gray-400">
                                Family Member
                              </td>
                            )}
                            <td className="p-2">
                              <button
                                type="button"
                                className={`${patientSearchActionBtn} px-5 py-2 text-white cursor-pointer shadow-[0_2px_8px_rgba(10,76,138,0.25)]`}
                                style={{
                                  background:
                                    "linear-gradient(90deg, #0A4C8A 0%, #00B58F 100%)",
                                }}
                                onClick={() =>
                                  navigate("/BookServicescard", {
                                    state: {
                                      patientCode: user.patientCode,
                                      patient: user,
                                      patientcbcode: user.curebayPatientId,
                                    },
                                  })
                                }
                              >
                                <Calendar className="h-4 w-4 shrink-0" strokeWidth={2.5} />
                                Book
                              </button>
                            </td>
                              <td className="p-2">
                                <button
                                  type="button"
                                  className={`${patientSearchActionBtn} cursor-pointer p-[2px] bg-gradient-to-r from-[#0A4C8A] to-[#00B58F]`}
                                  onClick={() =>
                                    navigate("/PatientDetails", {
                                      state: { patientCode: user.patientCode, curebayPatientId: user.curebayPatientId },
                                    })
                                  }
                                >
                                  <span className="inline-flex w-full items-center justify-center gap-2 rounded-[10px] bg-white px-5 py-2 text-[#0A7A6E]">
                                    <Eye className="h-4 w-4 shrink-0" strokeWidth={2.5} />
                                    View
                                  </span>
                                </button>
                              </td>
                              <td className="p-2 align-top">
                                <div className="flex flex-col gap-2">
                                  <PatientShareLinkButton
                                    label="Kavach Link"
                                    onClick={() => handleSendKavachLink(user)}
                                    disabled={sendingKavachCode === user.patientCode}
                                    isLoading={sendingKavachCode === user.patientCode}
                                  />
                                  <PatientShareLinkButton
                                    label="Quantum Link"
                                    onClick={() => handleSendQuantumLink(user)}
                                    disabled={sendingQuantumCode === user.patientCode}
                                    isLoading={sendingQuantumCode === user.patientCode}
                                  />
                                </div>
                              </td>
                              
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
            {searchInput.trim().length >= 3 && searchResults.length == 0 && (
              <div className="mt-4 bg-white border border-gray-300 rounded-md shadow-sm overflow-hidden">
                <div className="flex flex-col items-center justify-center text-center py-6 space-y-4">
                  <p className="text-gray-700">
                    We couldn't find this patient in our system. Let's get them
                    registered to continue.
                  </p>
                  <button
              className="bg-[#00BD7F] hover:bg-[#019a75] px-6 py-2 text-sm text-white rounded-full font-medium whitespace-nowrap transition-colors"
              onClick={() => navigate("/Patientregister", { state: { mobileNumber: (searchInput || "").replace(/[^0-9]/g, "") } })}
            >
            + Register Patient
          </button>
                </div>
              </div>
            )}
            <div className="mb-6 sm:mb-8">
              <h2 className="text-xl font-semibold text-[#004276] mb-4 sm:mb-6">
                Healthcare Services
              </h2>

              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
                {[
                  {
                    id: "appointment",
                    label: "Book Appointment",
                    icon: bookappointmenticon,
                    iconClass: "h-6 w-6",
                    onClick: () => navigate("/Patientregister"),
                  },
                  {
                    id: "medicine",
                    label: "Buy Medicine",
                    icon: nodabookmedicineiconta,
                    iconClass: "h-8 w-8",
                    onClick: () => navigate("/BookService"),
                  },
                  {
                    id: "lab",
                    label: "Book Lab Test",
                    icon: booklabicon,
                    iconClass: "h-8 w-8",
                    onClick: () => navigate("/BookService"),
                  },
                  {
                    id: "surgery",
                    label: "Book Surgery",
                    icon: surgery,
                    iconClass: "h-9 w-9",
                    onClick: () => navigate("/BookService"),
                  },
                  {
                    id: "ambulance",
                    label: "Book Ambulance",
                    icon: Ambulanceicon,
                    iconClass: "h-9 w-9",
                    onClick: () => navigate("/BookService"),
                    ambulance: true,
                  },
                ].map((service) => {
                  const isAmbulance = service.ambulance;
                  return (
                    <button
                      key={service.id}
                      type="button"
                      onClick={service.onClick}
                      className={`group relative flex flex-col items-center w-full min-h-[142px] rounded-xl border transition-colors ${
                        isAmbulance
                          ? "bg-[#FFF6F6] border-[#E8B4B4] hover:bg-[#FFEFEF] hover:border-[#E09090]"
                          : "bg-[#F5FCFF] border-[#BCEBFE] hover:bg-[#004276] hover:border-[#004276]"
                      }`}
                    >
                      {isAmbulance && (
                        <span className="absolute top-3 left-3 flex items-center gap-1.5 text-[11px] text-gray-600 font-normal">
                          <span className="w-2 h-2 rounded-full bg-[#FF3D42] shrink-0" />
                          Available 24/7
                        </span>
                      )}
                      <div className="flex flex-1 items-center justify-center w-full min-h-[96px] px-3 pt-9 pb-2">
                        {isAmbulance ? (
                          <img
                            src={service.icon}
                            alt={service.label}
                            className="w-14 h-14 object-contain shrink-0"
                          />
                        ) : (
                          <div className="flex items-center justify-center w-14 h-14 rounded-full bg-white shrink-0 border border-[#B6E4FF]">
                            <img
                              src={service.icon}
                              alt={service.label}
                              className={`object-contain ${service.iconClass}`}
                            />
                          </div>
                        )}
                      </div>
                      <span
                        className={`w-full px-3 pb-4 text-sm font-bold text-center leading-tight text-[#1E293B] ${
                          isAmbulance ? "" : "group-hover:text-white"
                        }`}
                      >
                        {service.label}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>

            {hospitalid ? (
            <div
              className="mb-6 sm:mb-8 grid grid-cols-1 lg:grid-cols-2 gap-4 items-stretch"
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              {/* Kavach banner */}
              <div className="rounded-3xl p-[1px] bg-gradient-to-br from-[#024C77] to-[#019A7D] min-w-0 h-full">
                <div
                  className="rounded-3xl h-full px-3 py-3 sm:px-4 sm:py-3 flex flex-col justify-center"
                  style={{
                    background:
                      "linear-gradient(135deg, #F0F9FA 0%, #EAF6F4 45%, #D6EFEB 100%)",
                  }}
                >
                  <h3 className="leading-[1.15]">
                    <span className="text-[15px] sm:text-[16px] font-semibold text-[#0B4D86]">
                      <span className="text-[#0B4D86]">Cure</span>
                      <span className="text-[#0A8A8F]">Bay</span>
                      <span className="text-[#0B4D86]"> Kavach</span>,
                    </span>{" "}
                    <span className="text-[11px] sm:text-[16px] font-medium text-[#0B4D86]">
                      Your Complete Health Protection Plan
                    </span>
                  </h3>
                  <p className="mt-0.5 text-[#4A5F6D] text-[10px] sm:text-[14px] leading-[1.3]">
                    Affordable care, diagnostic & medicines- all covered in one
                    simple plan.
                  </p>

                  <div className="-mt-[10px] flex gap-2 items-center">
                    <div className="flex-1 min-w-0 flex flex-col gap-2">
                      <div className="grid grid-cols-2 gap-1.5 w-[98%]">
                        <div className="bg-white rounded-lg px-2 py-1.5 border border-[#BFEADF] shadow-[0_2px_6px_rgba(0,66,118,0.06)]">
                          <div className="flex items-start gap-1">
                            <div className="h-5 w-5 rounded-full bg-[#DDF3EC] flex items-center justify-center shrink-0">
                              <img src={Kavachicon2} alt="" className="h-[10px] w-[10px]" />
                            </div>
                            <div className="min-w-0">
                              <p className="text-[11px] leading-[1.1]">
                                <span className="text-[#005A4E] font-semibold">CureBay Kavach</span>
                                <span className="text-[#1F2937]"> at</span>
                              </p>
                              <p className="text-[11px] font-semibold text-[#1F1F24] leading-none mt-0.5">
                                ₹499/year
                              </p>
                            </div>
                          </div>
                          <p className="mt-1 text-[#3D4652] text-[10px] sm:text-[10px] leading-[1.2] font-medium">
                            Essential protection for every family
                          </p>
                        </div>
                        <div className="bg-white rounded-lg px-2 py-1.5 border border-[#B7D6FF] shadow-[0_2px_6px_rgba(0,66,118,0.06)]">
                          <div className="flex items-start gap-1">
                            <div className="h-5 w-5 rounded-full bg-[#DEEAFB] flex items-center justify-center shrink-0">
                              <img src={Kavachicon2} alt="" className="h-[10px] w-[10px]" />
                            </div>
                            <div className="min-w-0">
                              <p className="text-[11px] leading-[1.1]">
                                <span className="text-[#0A5FA8] font-semibold">CureBay Kavach Plus</span>
                                <span className="text-[#1F2937]"> at</span>
                              </p>
                              <p className="text-[11px] font-semibold text-[#1F1F24] leading-none mt-0.5">
                                ₹999/year
                              </p>
                            </div>
                          </div>
                          <p className="mt-1 text-[#3D4652] text-[10px] sm:text-[10px] leading-[1.2] font-medium">
                            Enhanced benefits for complete care
                          </p>
                        </div>
                      </div>

                     
                    </div>

                    <div className="shrink-0 flex items-center">
                      <img
                        src={Kavachicon}
                        alt="Kavach family"
                        className="w-[72px] sm:w-[80px] lg:w-[144px] h-auto"
                      />
                    </div>
                  </div>

                  <div className="flex items-end justify-between gap-1.5 mt-3">
                        <div className="grid grid-cols-4 gap-x-1 gap-y-0.5 min-w-0 flex-1">
                          <div className="flex flex-col items-start gap-1 text-[#032D52] text-[7px] sm:text-[8px] font-semibold uppercase tracking-[0.03em]">
                            <img src={Kavachicon1} alt="" className="h-3 w-3" />
                            <span className="flex flex-col gap-0.5 leading-snug">
                              <span>Hospital</span>
                              <span>Protection</span>
                            </span>
                          </div>
                          <div className="flex flex-col items-start gap-1 text-[#032D52] text-[7px] sm:text-[8px] font-semibold uppercase tracking-[0.03em]">
                            <img src={Kavachicon2} alt="" className="h-3 w-3" />
                            <span className="flex flex-col gap-0.5 leading-snug">
                              <span>Preventive</span>
                              <span>Care</span>
                            </span>
                          </div>
                          <div className="flex flex-col items-start gap-1 text-[#032D52] text-[7px] sm:text-[8px] font-semibold uppercase tracking-[0.03em]">
                            <img src={Kavachicon3} alt="" className="h-3 w-3" />
                            <span className="flex flex-col gap-0.5 leading-snug">
                              <span>Exclusive</span>
                              <span>Benefits</span>
                            </span>
                          </div>
                          <div className="flex flex-col items-start gap-1 text-[#032D52] text-[7px] sm:text-[8px] font-semibold uppercase tracking-[0.03em]">
                            <img src={Kavachicon4} alt="" className="h-3 w-3" />
                            <span className="flex flex-col gap-0.5 leading-snug">
                              <span>Expert</span>
                              <span>Support</span>
                            </span>
                          </div>
                        </div>
                        <a
                          href={getKavachEnrollmentUrl()}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="shrink-0 inline-flex bg-gradient-to-r from-[#1E4B7A] to-[#40917A] text-white rounded-full px-2.5 sm:px-3 py-2 text-[9px] sm:text-[10px] font-medium items-center gap-0.5 hover:opacity-95 transition-opacity whitespace-nowrap shadow-[0_2px_8px_rgba(30,75,122,0.25)]"
                        >
                          Get Your Kavach Now
                          <span className="text-sm leading-none">→</span>
                        </a>
                      </div>
                </div>
              </div>

              {/* Quantum banner */}
              <div
                className="relative rounded-[24px] border border-[#B39DDB]/50 overflow-hidden min-w-0 "
                style={{
                  background:
                    "linear-gradient(90deg, #F3E5F5 0%, #EDE7F6 45%, #E3F2FD 100%)",
                }}
              >
                <div className="relative z-10  flex flex-col justify-center px-3 py-3 sm:px-4 sm:py-4 pb-28 sm:pb-4 max-w-full lg:max-w-[calc(100%-120px)] xl:max-w-[calc(100%-120px)]">
                  <span
                    className="inline-flex w-fit items-center gap-1 rounded-full px-2.5 py-1 text-[10px] lg:text-[11px] font-medium text-white leading-none"
                    style={{
                      background:
                        "linear-gradient(90deg, #8E24AA 0%, #5C6BC0 100%)",
                    }}
                  >
                    <span>•</span>
                    AI-Powered
                    <span>•</span>
                    Quantum Solutions
                  </span>
                  <h3 className="mt-1.5 text-[16px] sm:text-[18px] xl:text-[20px] font-bold leading-[1.12]">
                    <span className="text-[#AB47BC]">Smart Health,</span>{" "}
                    <span className="text-[#1A237E]">Powered By AI</span>
                  </h3>
                  <p className="mt-0 mb-2 text-[10px] sm:text-[14px] leading-[1.4] text-[#283593] font-normal">
                    CureBay&apos;s intelligent AI pre-screening delivers instant
                    insights - making healthcare smarter, faster, and more
                    personalized.
                  </p>
                  <div className="mt-2 flex flex-col gap-1.5">
                    <div className="flex flex-wrap gap-1.5 lg:gap-2">
                      {QUANTUM_AI_FEATURES.slice(0, 4).map((feature) => (
                        <span
                          key={feature}
                          className="inline-flex items-center rounded-full border border-[#CE93D8] bg-white px-2 py-1 text-[9px] lg:text-[11px] font-medium text-[#6A1B9A] leading-none whitespace-nowrap"
                        >
                          {feature}
                        </span>
                      ))}
                    </div>
                    <div className="flex flex-wrap gap-1.5 lg:gap-2">
                      {QUANTUM_AI_FEATURES.slice(4).map((feature) => (
                        <span
                          key={feature}
                          className="inline-flex items-center rounded-full border border-[#CE93D8] bg-white px-2 py-1 text-[9px] lg:text-[11px] font-medium text-[#6A1B9A] leading-none whitespace-nowrap"
                        >
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                </div>
                <img
                  src={Quantumbanner}
                  alt="AI-powered health solutions"
                  className="pointer-events-none absolute right-0 lg:right-0 bottom-0 top-7 h-[120px] lg:h-[130px] xl:h-[180px] w-auto max-w-[42%] object-contain object-bottom"
                />
                <div className="mt-2.5 shrink-0 ml-5">
                    <button
                      type="button"
                      onClick={handleExploreQuantum}
                      className="inline-flex items-center gap-2 rounded-full px-4 py-1 text-[10px] sm:text-[11px] font-semibold text-white hover:opacity-95 transition-opacity shadow-[0_4px_12px_rgba(26,35,126,0.3)] whitespace-nowrap"
                      style={{
                        background:
                          "linear-gradient(90deg, #8E24AA 0%, #3949AB 50%, #1A237E 100%)",
                      }}
                    >
                      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white/20">
                        <img
                          src={Quantumicon}
                          alt=""
                          className="h-4 w-4"
                        />
                      </span>
                      Explore AI Solutions
                      <span className="text-sm leading-none ml-0.5">→</span>
                    </button>
                  </div>
              </div>
              
            </div>
            ) : null}

            <div className="grid grid-cols-2 gap-6">
              <DoctorAvailabilitySection
                doctorAvailabilityDate={doctorAvailabilityDate}
                setDoctorAvailabilityDate={setDoctorAvailabilityDate}
                selectedSpecialization={selectedSpecialization}
                setSelectedSpecialization={setSelectedSpecialization}
              />
              <OngoingPatientSection />

              {/* Row 2 */}
            </div>

            <div className="grid grid-cols-1 mt-8 mb-6">
              <TodayAppointments
                appointments={todayAppointments}
                dateRange={dateRange}
                setDateRange={setDateRange}
                paidStatus={paidStatus}
                setPaidStatus={setPaidStatus}
                refetchAppointments={fetchTodayAppointments}
              />
            </div>
            {/* <TodayAppointments/>
              <PharmacyOrdersSection /> */}
            {!disabledFeatures.includes("schedule-service") && (
              <div className="grid grid-cols-2 gap-6">
                <PharmacyOrders orders={medorders} />
                <PathologyOrders orders={pathologyorders} />
                {/* Row 3 */}
                {/* <LabOrdersSection /> */}
                {/* <SurgeryOrdersSection /> */}
              </div>
            )}

            {!disabledFeatures.includes("schedule-service") && (
              <div className="grid grid-cols-2 gap-6 mt-8 mb-6">
                <RadiologyOrders orders={radiologyorders} />
                <Surgery />
              </div>
            )}
            <div
              className={`grid gap-6 mt-8 mb-6 ${
                !disabledFeatures.includes("schedule-service")
                  ? "grid-cols-2"
                  : "grid-cols-1"
              }`}
            >
              <FollowUpPatients />
              <AmbulanceOrders />
            </div>
          </div>
        </div>
      </OurLayouts>
      {isRescheduleOpen && (
        <RescheduleSidebar
          isOpen={isRescheduleOpen}
          onClose={handleCloseReschedule}
          selectedToken={selectedToken}
          appontmentdate={rescheduleDate}
          selectedSlot={selectedSlot}
          setSelectedSlot={setSelectedSlot}
          selectedappointmentid={selectedappointmentid}
          doctorid={selecteddoctorid}
        />
      )}

      {isdelayedOpen && (
        <Delaysidebar
          isOpen={isdelayedOpen}
          doctordata={doctordata}
          onClose={handleclosesidebar}
          handleConfirmDelay={handleConfirmDelay}
          selectedHour={selectedHour}
          setSelectedHour={setSelectedHour}
          selectedMinute={selectedMinute}
          setSelectedMinute={setSelectedMinute}
          dayofweek={dayofweek}
          setDayofweek={setDayofweek}
          fromTime={fromTime}
          setFromTime={setFromTime}
          toTime={toTime}
          setToTime={setToTime}
        />
      )}

      {/* ABHA Verification Modal */}
      {isAbhaVerifyOpen && selectedPatientForAbha && (
        <VerifyAbhaModal
          visible={isAbhaVerifyOpen}
          onClose={handleAbhaClose}
          mobileNumber={selectedPatientForAbha.mobileNumber}
          onSuccess={handleAbhaSuccess}
          onCreateAbha={() => {
            setIsAbhaVerifyOpen(false);
            setIsAbhaCreateOpen(true);
          }}
        />
      )}

      {/* ABHA Creation Modal */}
      {isAbhaCreateOpen && selectedPatientForAbha && (
        <CreateAbhaModal
          isOpen={isAbhaCreateOpen}
          onClose={handleAbhaClose}
          onSuccess={handleAbhaSuccess}
          initialMobileNumber={selectedPatientForAbha.mobileNumber}
          showAsModal={true}
        />
      )}
    </>
  );
};

export default Dashboard;
